var map = {
	"./deafening.png": "./src/assets/pngs/wave-line/deafening.png",
	"./extremely-loud.png": "./src/assets/pngs/wave-line/extremely-loud.png",
	"./inaudible.png": "./src/assets/pngs/wave-line/inaudible.png",
	"./loud.png": "./src/assets/pngs/wave-line/loud.png",
	"./mellow.png": "./src/assets/pngs/wave-line/mellow.png",
	"./pulsating.png": "./src/assets/pngs/wave-line/pulsating.png",
	"./quiet.png": "./src/assets/pngs/wave-line/quiet.png",
	"./resonant.png": "./src/assets/pngs/wave-line/resonant.png",
	"./rhythmic.png": "./src/assets/pngs/wave-line/rhythmic.png",
	"./sonorous.png": "./src/assets/pngs/wave-line/sonorous.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/pngs/wave-line sync recursive ^\\.\\/.*\\.png$";